module.exports = __webpack_public_path__ + "img/public_icon.54c4e501.png";